export default "__VITE_ASSET__Cvnb2$Fs__"